export const formatAddress = (fullAddress?: string): string | undefined => {
  if (!fullAddress) return undefined;

  const parts = fullAddress.split(",").map((part) => part.trim());

  if (parts.length === 0) return fullAddress.trim();
  if (parts.length === 1) return parts[0];

  if (parts.length >= 2) {
    const secondPart = parts[1];
    const isZipCode = /^\d{4,5}$/.test(secondPart);
    const isNumeric = /^\d+$/.test(secondPart);
    const shouldIncludeSecondPart = !isZipCode && isNumeric;

    return shouldIncludeSecondPart ? `${parts[0]}, ${secondPart}` : parts[0];
  }

  return parts[0];
};
